import { enumElementDrawStates, enumFillMode, kDisableColor, kSmallIcon } from "../constants";
import { QButton } from "./QButton";

export class QColorSetButton extends QButton {
  constructor() {
    super();
    this.fSizing = kSmallIcon;
    this.fDocMgr = null;
  }

  SetDocMgr(docMgr) {
    this.fDocMgr = docMgr;
  }

  SetSizing(sizing) {
    this.fSizing = sizing;
  }

  RenderInterior(drawBuffer, disabled) {
    var interiorColor = kDisableColor;
    var interiorColor2 = null;

    var fm = this.GetFillMode();

    if (!disabled && fm != enumFillMode.noFill) {
      interiorColor = this.GetFillColor();
      interiorColor2 = this.GetFillColor2();
    }

    var dstWidth = this.fSizing.imageWidth - 8;
    var dstHeight = this.fSizing.imageHeight - 8;
    var xPos = this.fHorzOffset + (this.fWidth - dstWidth) / 2;
    var yPos = this.fVertOffset + (this.fHeight - dstHeight) / 2 + 1;

    var ctx = drawBuffer.getContext("2d");

    ctx.fillStyle = "#7f7f7f";
    ctx.fillRect(xPos - 1, yPos - 1, dstWidth + 2, dstHeight + 2);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(xPos, yPos, dstWidth, dstHeight);
    if (fm == enumFillMode.linearGradientDown) {
      var grd = ctx.createLinearGradient(xPos + 1, yPos + 1, xPos + 1, dstHeight - 2 + yPos + 1);
      if (interiorColor == null) interiorColor = "#FFFFFF";
      if (interiorColor2 == null) interiorColor = "#FFFFFF";
      grd.addColorStop(0, interiorColor);
      grd.addColorStop(1, interiorColor2);
      ctx.fillStyle = grd;
      ctx.fillRect(xPos + 1, yPos + 1, dstWidth - 2, dstHeight - 2);
    } else if (fm == enumFillMode.solidFill) {
      ctx.fillStyle = interiorColor;
      ctx.fillRect(xPos + 1, yPos + 1, dstWidth - 2, dstHeight - 2);
    }
  }

  DoRenderContent(drawBuffer) {
    var disabled = this.GetDrawState() == enumElementDrawStates.Disabled;
    this.RenderInterior(drawBuffer, disabled);
  }
}
